import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { toast } from 'react-hot-toast';
import ClockLoader from 'shared/components/ClockLoader';
import { apiErrorMessage } from '../../utils/responseHelpers';

const DeleteSoftwareDialog = ({ open, onClose, onSuccess, row, removeItem }) => {
  const [submitting, setSubmitting] = useState(false);

  if (!row) return null;

  const systemName =
    (typeof row.softwareName === 'string' && row.softwareName.trim()) ||
    (typeof row.name === 'string' && row.name.trim()) ||
    'this system';

  const handleConfirm = async () => {
    setSubmitting(true);
    try {
      await removeItem(row.id);
      toast.success(`"${systemName}" was deleted`);
      onSuccess?.();
      onClose();
    } catch (error) {
      toast.error(apiErrorMessage(error, 'Failed to delete system.'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>Delete system?</DialogTitle>
      <DialogContent>
        <Typography>Do you want to delete the system?</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={submitting} sx={{ textTransform: 'none' }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleConfirm}
          disabled={submitting}
          sx={{ textTransform: 'none' }}
        >
          {submitting ? <ClockLoader inline size={22} /> : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteSoftwareDialog;
